
export const getKycStatusMessage = (
  basicStatus: number,
  businessStatus: number,
  bankStatus: number
): string => {
  // BASIC
  if (basicStatus === 0) {
    return 'Please complete your basic information to proceed with account activation.';
  }

  if (basicStatus === 1) {
    return 'Your basic information is under review. We’ll notify you once it’s verified.';
  }

  if (basicStatus === 3) {
    return 'Your basic information was rejected. Please review and resubmit the details.';
  }

  // BUSINESS
  if (businessStatus === 0) {
    return 'Please complete your business details to activate your merchant account.';
  }

  if (businessStatus === 1) {
    return 'Your business details are currently under review.';
  }

  if (businessStatus === 3) {
    return 'Your business details were rejected. Please update and resubmit them.';
  }

  // BANK
  if (bankStatus === 0) {
    return 'Please add your bank account details to complete your profile activation.';
  }

  if (bankStatus === 1) {
    return 'Your bank details are under review. Verification is in progress.';
  }

  if (bankStatus === 3) {
    return 'Your bank details were rejected. Please correct the information and try again.';
  }

  return 'Your profile is being processed.';
};
